import { Injectable } from "@angular/core";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { firstValueFrom } from "rxjs";
import { Gutachten } from "../../api/models/gutachten";
import { GutachtenService } from "../../api/services/gutachten.service";

@Injectable({
  providedIn: "root",
})
export class BerichtService {
  constructor(
    private gutachtenService: GutachtenService,
    private oidcSecurityService: OidcSecurityService,
  ) {}

  async fetchGutachten(aktId: number, gutachtenId: number): Promise<Gutachten> {
    return await firstValueFrom(
      this.gutachtenService.gutachtenRetrieveCreate({
        akt_id: aktId,
        gutachten_id: gutachtenId,
        token: this.oidcSecurityService.getToken(),
      }),
    );
  }
}
